module.exports = __webpack_public_path__ + "prod/1.42.2/img/pre_high_img3.66ed6a54.png";